// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"126":"f65a48b9","634":"2c796e83"}[chunkId] || chunkId) + "." + {"126":"8bb188dcd799fb21","224":"7e1585a4118b0065","308":"2e97e8267b7c79ca","344":"c39e473e5dbd68a8","634":"b068b47ecccad0cc","729":"e95dbf043ac042db"}[chunkId] + ".js";
};